export const conversationTagsConstants = {
    CONVERSATION_TAGS_SUCCESS: 'CONVERSATION_TAGS_SUCCESS',
    CONVERSATION_TAGS_ERROR: 'CONVERSATION_TAGS_ERROR',
};

export const TAG_NAME_MAX_LENGTH = 50;

export const TAG_COLORS = ['#1F93FF', '#0FA573', '#F2A50C', '#E5484D', '#8E55EA', '#0EAABF', '#EE6F9C', '#5D6B82'];
